import { coordinatesInBoard, DEFAULT_BOMBS_NUMBER, DEFAULT_SIZE, getBooleanMatrix, getDirectionsWithDiagonals, getNumberMatrix, } from './BoardHelper';
import BoardState from './BoardState';
import CellType from './CellType';
export default class Board {
    constructor(size, bombsNumber, level) {
        const actualSize = size > 0
            ? size
            : DEFAULT_SIZE;
        const actualBombsNumber = bombsNumber > 0
            ? bombsNumber
            : DEFAULT_BOMBS_NUMBER;
        this.content = getBoardContent(actualSize, actualBombsNumber);
        this.visited = getBooleanMatrix(actualSize);
        this.flagged = getBooleanMatrix(actualSize);
        this.size = actualSize;
        this.level = level;
        this.bombsNumber = actualBombsNumber;
        this.state = BoardState.INITIAL;
        this.remainingNotVisited = size * size - bombsNumber;
        this.availableFlags = actualBombsNumber;
    }
    withFlagged(flagged) {
        this.flagged = flagged;
        return this;
    }
    withState(state) {
        this.state = state;
        return this;
    }
}
function getBoardContent(size, bombsNumber) {
    const bombPositions = getBombPositions(size, bombsNumber);
    const board = placeBombs(getNumberMatrix(size, 0), bombPositions);
    return markAdjacentCells(board, bombPositions);
}
function getBombPositions(size, bombsNumber) {
    const bombPositions = new Set();
    while (bombPositions.size !== bombsNumber) {
        const randomPositions = generatePosition(size);
        bombPositions.add(`${String(randomPositions[0])}-${String(randomPositions[1])}`);
    }
    const positionsArray = Array.from(bombPositions)
        .map((str) => {
        const split = str.split('-');
        return [Number(split[0]), Number(split[1])];
    });
    return new Set(positionsArray);
}
function markAdjacentCells(board, bombPositions) {
    const markedBoard = board;
    const directions = getDirectionsWithDiagonals();
    bombPositions.forEach((coord) => {
        const [x, y] = [coord[0], coord[1]];
        directions.forEach((dir) => {
            const xi = x + dir[0];
            const yi = y + dir[1];
            if (coordinatesInBoard(xi, yi, markedBoard) && markedBoard[xi][yi] !== CellType.BOMB) {
                markedBoard[xi][yi] += 1;
            }
        });
    });
    return markedBoard;
}
function placeBombs(board, bombPositions) {
    const newBoard = board;
    bombPositions.forEach((coord) => {
        const [x, y] = [coord[0], coord[1]];
        newBoard[x][y] = CellType.BOMB;
    });
    return newBoard;
}
function generatePosition(size) {
    return [getRandomInt(0, size), getRandomInt(0, size)];
}
// The maximum is exclusive and the minimum is inclusive
function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}
